module.exports = __webpack_public_path__ + "static/img/LV.e5d85788.jpg";